import React from 'react'
import HoliosComponent from '../components/HoliosComponent'

export default function Holios() {
  return (
    <div>
      <HoliosComponent/>
    </div>
  )
}
